import { render } from "./ClassAddView.vue?vue&type=template&id=096cec1e"
import script from "./ClassAddView.vue?vue&type=script&lang=js"
export * from "./ClassAddView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__